import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../dynamic-form/odin-controller.component';
import type { ToggleButtonProps } from './toggle-button';
import ToggleButton from './toggle-button';

export interface HfToggleButtonProps extends ToggleButtonProps {
  control: Control<FieldValues>;
}

function HfToggleButton(props: HfToggleButtonProps) {
  const { control, name, onChange, checked } = props;

  return (
    <OdinController
      control={control}
      name={name ?? 'toggle-button'}
      onChange={onChange}
      defaultValue={checked}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return <ToggleButton {...props} onChange={onChange} checked={value} error={error?.message} />;
      }}
    ></OdinController>
  );
}

export default HfToggleButton;
